export const HIGHLIGHT_ANIMATION_DURATION_MS = 1800;
export const LONG_SCROLL_HIGHLIGHT_DELAY_MS = 850;

export const triggerBookingFormHighlight = (bookingFormRef) => {
  const formNode = bookingFormRef.current;
  if (!formNode) return;

  formNode.classList.remove('booking-form-attention');
  void formNode.offsetWidth;
  formNode.classList.add('booking-form-attention');

  window.setTimeout(() => {
    formNode.classList.remove('booking-form-attention');
  }, HIGHLIGHT_ANIMATION_DURATION_MS);
};

export const scrollToBookingForm = (bookingFormRef) => {
  requestAnimationFrame(() => {
    const formNode = bookingFormRef.current;
    if (!formNode) return;
    const formRect = formNode.getBoundingClientRect();
    const formAlreadyVisible = formRect.top >= 0 && formRect.top < window.innerHeight - 120;

    formNode.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if (formAlreadyVisible) {
      triggerBookingFormHighlight(bookingFormRef);
      return;
    }

    window.setTimeout(() => triggerBookingFormHighlight(bookingFormRef), LONG_SCROLL_HIGHLIGHT_DELAY_MS);
  });
};